export default __webpack_public_path__ + "static/media/shopping-cart.14dd77ef.svg";